
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publications/[slug]",
      function () {
        return require("private-next-pages/publications/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publications/[slug]"])
      });
    }
  